var exports = {
  "B8": "List__7yneBe",
  "q7": "Item__YGi5FZ",
  "hE": "Title__DTMQT7",
  "Ie": "Excerpt__dqGw4t",
  "s0": "Url__5c8TKB",
};

module.exports = exports;
